import React from 'react';
import {useParams} from 'react-router-dom';
import {LayoutSidebar} from '../../Layout';
import {ClientIATabContent} from './ClientIATabContent';

// Wrapper de ruta del tab IA (ficha v2): /client/:id/ia/:view? y /client/:id/ia/dashbito/:sessionId.
// Como todo tab de la ficha, monta el sidebar global (sin esto la franja izquierda queda vacía).
export function ClientIATab() {
    const params = useParams();
    return (
        <div className="app-content">
            <LayoutSidebar/>
            <ClientIATabContent
                clientId={params.id}
                view={params.view || (params.sessionId ? 'dashbito' : undefined)}
                sessionId={params.sessionId}
            />
        </div>
    );
}
